<template>
    <div class="content-wrapper">
        <!-- <div v-if="loader" class="page_loader"></div> -->
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-2">
                        <h1 class="m-0 text-dark">New Booking</h1>
                        <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="isUnderReview">
                            <strong>Sorry, This merchant have under review parcel. Please entry from <router-link to="/under-review-form">Under Review</router-link></strong>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <button class="btn btn-success float-right btn-sm mr-2" @click="bulkModal.show()"><i class="fas fa-upload"></i> Bulk Upload</button>
                        <router-link to="/order-requesting" class="btn btn-secondary float-right btn-sm mr-2" ><i class="fas fa-list"></i> Requested Order</router-link>
                        <router-link to="/order-process" class="btn btn-primary float-right btn-sm mr-2" ><i class="fas fa-list"></i> Process</router-link>
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row booking-page">
                    <div class="col-lg-7 col-md-8 col-sm-12 col-xs-12">
                        <div class="card">
                            <div class="card-body"> 
                                <b-overlay :show="loading">
                                    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                        <form @submit.prevent="handleSubmit(saveForm)" :class=" isUnderReview ? 'text-red' : 'text-black'">
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-9 col-xs-12">
                                                    <ValidationProvider name="Merchant" vid="merchant_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="merchant_id">Merchant <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="merchant_id"
                                                                v-model="form.merchant_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= commonObj.merchantList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div> 
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-9 col-xs-12">
                                                    <ValidationProvider name="Store" vid="store_id" v-slot="{errors}">
                                                        <div class="form-group">
                                                            <label for="merchant_id">Store </label>
                                                            <v-select name="store_id"
                                                                v-model="form.store_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= storeList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>                                            
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Date" vid="date" v-slot="{errors}">
                                                        <div class="form-group">
                                                            <label for="date">Deadline <span class="text-danger" title="Required">*</span></label>
                                                            <input type="date" id="date" v-model="form.date" class="form-control" placeholder="Deadline" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Mobile" vid="mobile" v-slot="{errors}" rules="required|min:11|max:11">
                                                        <div class="form-group">
                                                            <label for="mobile">Mobile No<span class="text-danger" title="Required">*</span></label>
                                                            <input type="text" id="mobile" v-model="form.mobile" class="form-control" placeholder="Mobile No" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Alternatvie Mobile" vid="mobile_2" v-slot="{errors}">
                                                        <div class="form-group">
                                                            <label for="mobile_2">Alt. Mobile No</label>
                                                            <input type="text" id="mobile_2" v-model="form.mobile_2" class="form-control" placeholder="Alternatvie Mobile No" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Reference ID" vid="ref_id" v-slot="{errors}">
                                                        <div class="form-group">
                                                            <label for="ref_id">Reference ID</label>
                                                            <input type="text" id="ref_id" v-model="form.ref_id" class="form-control" placeholder="Reference ID" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Address" vid="address" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="address">Address <span class="text-danger" title="Required">*</span></label>
                                                            <input type="text" id="address"
                                                                v-model="form.address" 
                                                                class="form-control" 
                                                                placeholder="Address" 
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="District" vid="district_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="district_id">District <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="district_id"
                                                                v-model="form.district_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= commonObj.districtList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Thana" vid="thana_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="thana_id"> Thana <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="thana_id"
                                                                v-model="form.thana_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= thanaList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div> -->
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Thana" vid="thana_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="thana_id">Select District - Thana <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="thana_id"
                                                                v-model="form.thana_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= commonObj.districtThanaList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Area" vid="area_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="area_id">Area <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="area_id"
                                                                v-model="form.area_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= areaList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div> 
                                                <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12">
                                                    <ValidationProvider name="Area" vid="area_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="area_id">Area <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="area_id"
                                                                v-model="form.area_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= merchantAreaList
                                                                :filterable="false"
                                                                @search="onAreaSearch"
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div> -->
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-xs-12">
                                                    <ValidationProvider name="Destination" vid="destination_hub_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="thana_id">Destination Hub <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="thana_id"
                                                                v-model="form.destination_hub_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= commonObj.hubList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Price" vid="price" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="price">Price <span class="text-danger" title="Required">*</span></label>
                                                            <input type="text" id="price" v-model="form.price" class="form-control" placeholder="Price" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Name" vid="name" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="name">Name <span class="text-danger" title="Required">*</span></label>
                                                            <input type="text" id="name" v-model="form.name" class="form-control" placeholder="Customer Name" required @keydown.enter.prevent="saveForm" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Instruction (Note)" vid="instruction" v-slot="{errors}">
                                                        <div class="form-group">
                                                            <label for="instruction">Instruction (Note)</label>
                                                            <input type="text" id="instruction" v-model="form.instruction" class="form-control" placeholder="Instruction (Note)" @keydown.enter.prevent="saveForm" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Description" vid="description" v-slot="{errors}">
                                                        <div class="form-group">
                                                            <label for="description">Product Description</label>
                                                            <input type="text" id="description" v-model="form.description" class="form-control" placeholder="Product Description" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Weight(kg)" vid="weight" v-slot="{errors}">
                                                       <div class="form-group">
                                                            <label for="weight">Weight(kg) </label>
                                                            <input type="text" id="weight" v-model="rawWeight" @blur="formatWeight" class="form-control" placeholder="Weight" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Weight Charge" vid="weight_charge" v-slot="{errors}">
                                                        <div class="form-group">
                                                            <label for="weight_charge">Weight Charge <span class="text-danger" title="Required">*</span></label>
                                                            <input type="text" id="weight_charge" v-model.number="form.weight_charge" class="form-control" 
                                                                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" 
                                                                @keydown.enter.prevent="saveForm"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>                                                
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Exchange" vid="exchange" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="exchange">Exchange <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="exchange"
                                                                v-model="form.exchange"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= exchangeList
                                                                @keydown.enter.prevent="saveForm"
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <ValidationProvider name="Category" vid="category_id" v-slot="{errors}" rules="required|min_value:1">
                                                        <div class="form-group">
                                                            <label for="category_id">Category <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="category_id"
                                                                v-model="form.category_id"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= customState.categoryList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>  
                                            </div>
                                            <div class="row" v-if="!isUnderReview">
                                                <div class="ccol-xl-10 col-lg-10 col-md-10 col-sm-6 col-xs-12"></div>
                                                <div class="ccol-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 text-right">
                                                    <div class="form-group">
                                                        <button type="button" class="btn btn-info mr-2 mt-40" @click.prevent="saveForm">Submit</button>
                                                        <!-- <button type="reset" class="btn btn-danger btn-sm mt-30">Cancel</button> -->
                                                    </div>
                                                </div>
                                            </div>  
                                            <div class="row mt-1" v-if="fraudResponse">
                                                <div class="col text-center">
                                                    <p>
                                                        <span class="text-danger">Total Cancel: {{ fraud.total_cancel }}</span> | 
                                                        <span class="text-success">Total Delivered: {{ fraud.total_success }} | Success Rate: {{ fraud.success_rate }}%</span>
                                                    </p>
                                                </div>
                                            </div>  
                                        </form>
                                    </ValidationObserver>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <div ref="bulkUploadModal" class="modal fade" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <BulkUpload :bulkModal="bulkModal" :merchantList="commonObj.merchantList"></BulkUpload>
        </div>
    </div>
</template>
<script>
    import config from '@/config'
    import { Modal } from 'bootstrap'
    import BulkUpload from './BulkUpload.vue'
    import moment from 'moment'
    import Label from './Label.js'
    export default {
        name:'Booking',
        components: {
            BulkUpload: BulkUpload
        },
        data () {
            return {
                bulkModal: 0,
                loading: false,
                orderLoading: false,
                rawWeight: '',
                form: {
                    merchant_id : '',
                    store_id: null,
                    name : '',
                    mobile : '',
                    mobile_2 : '',
                    coverage_area_id: '',
                    division_id: '',
                    district_id: '',
                    thana_id: '',
                    zone_id: '',
                    area_id: '',
                    destination_hub_id: '',
                    address: '',
                    ref_id: '',
                    instruction: '',
                    description: '',
                    category_id: 1,
                    type: 1,
                    date: moment().format('YYYY-MM-DD'),
                    price: 0, // Amount to collected
                    weight: 0,
                    weight_charge: 0,
                    exchange: 2
                },
                exchangeList: [
                    { id: 1, text: 'Yes' },
                    { id: 2, text: 'NO' },
                ],
                search: {
                    merchant_id: '',
                    mobile: ''
                },
                districtList: [],
                thanaList: [],
                zoneList: [],
                areaList: [],
                orders: [],
                printOrders: [],
                storeList: [],
                weightList: [],
                isUnderReview: false,
                fraudResponse: false,
                fraud: null,
                total: 0,
                pagination: {
                    currentPage: 1,
                    totalRows: 0,
                    perPage: this.$store.state.commonObj.perPage,
                    slOffset: 1
                },
                merchantDetails: null,
                subAreaCoverageThanaIds: [],
                merchantAreaList: [],
                lastSearch: '',
            }
        },
        watch: {
            'form.district_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.thanaList = this.getThanaList(newVal)
                }
            },
            'form.thana_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.areaList = this.getAreaList(newVal)
                }
            },
            'form.area_id': function (newVal, oldVal) {
                if (newVal != oldVal && newVal != 0) {
                    this.setHub(newVal)
                }
            },
            'form.mobile': function (newVal, oldVal) {
                if (newVal != oldVal && newVal.length >= 11) {
                    this.search.mobile = newVal
                }
            },
            'search.mobile': function (newVal, oldVal) {
                if (newVal != oldVal && newVal.length >= 11) {
                    this.search.mobile = newVal
                }
            },
            'search.merchant_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.search.merchant_id = newVal
                }
            },
            'form.merchant_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.setMerchantDetails(newVal)
                    this.checkUnderReviewParcel()
                    this.getMerchantStore(newVal)
                    this.getMerchantWeightCharges(newVal)
                }
            },
            'form.date': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.checkUnderReviewParcel()
                }
            },
            rawWeight(val) {
                this.form.weight = val;
            }
        },
        created() {
            const inputDate = moment(); // Replace this with your actual date and time
            // Check if the time is before 8:30 AM
            if (inputDate.isBefore(inputDate.clone().set({ hour: 8, minute: 30, second: 0, millisecond: 0 }))) {
                this.form.date = moment().subtract(1,'d').format('YYYY-MM-DD')
            } else {
                this.form.date = moment().format('YYYY-MM-DD')
            }
            this.weightList = this.commonObj.weightChargeList

            // this.debounceSearch = this.debounce((search, loading) => {
            //     this.fetchAreas(search).finally(() => loading(false));
            // }, 500);
        },
        mounted() {
            this.bulkModal = new Modal(this.$refs.bulkUploadModal)
            // this.fetchAreas();
        },
        computed : {
            authUser () {
                return this.$store.state.authUser
            },
            customState () {
                return this.$store.state
            },
            commonObj () {
                return this.$store.state.commonObj
            }
        },
        methods:{
            // debounce(func, wait) {
            //     let timeout;
            //     return function executedFunction(...args) {
            //         const later = () => {
            //             clearTimeout(timeout);
            //             func(...args);
            //         };
            //         clearTimeout(timeout);
            //         timeout = setTimeout(later, wait);
            //     };
            // },
            // onAreaSearch(search, loading) {
            //     if (search !== this.lastSearch && search.length > 0) {
            //         loading(true);
            //         this.debounceSearch(search, loading);
            //         this.lastSearch = search; // Update last search query
            //     } else if (search.length === 0) {
            //         this.lastSearch = '';
            //     }
            // },
            // async fetchAreas(search = '') {
            //     try {
            //         const param = { search };
            //         const response = await config.getData('/order/merchant-area', param);
            //         if (response.success) {
            //             this.merchantAreaList = response.data;
            //         } else {
            //             this.merchantAreaList = [];
            //         }
            //     } catch (error) {
            //         this.merchantAreaList = [];
            //         console.error('Error fetching areas:', error);
            //     }
            // },
            // async districtThanaList () {
            //     this.orderLoading = true
            //     const response = await config.getData(`/order/district-thana`)
            //     this.orderLoading = false
            //     if (response.success) {
            //         this.thanaList = response.data
            //     } else {
            //        this.thanaList = []
            //     }
            // },
            async underReviewOrder () {
                this.orderLoading = true
                const param = { merchant_id: this.search.merchant_id, mobile: this.search.mobile}
                const response = await config.getData(`/order/under-review`, param)
                this.orderLoading = false
                if (response.status == 200) {
                    this.total = response.total
                    this.orders = response.data.data
                } else {
                    this.total = 0
                    this.orders = []
                }
            },
            async getMerchantStore (merchantId) {
                const response = await config.getData(`/order/merchant-store-list/${merchantId}`)
                if (response.status == 200) {
                    this.storeList = response.data
                } else {
                    this.storeList = []
                }
            },
            async getMerchantWeightCharges (merchantId) {
                const response = await config.getData(`/order/merchant-weight-list/${merchantId}`)
                if (response.status == 200) {
                    this.weightList = response.data.length > 0 ? response.data : this.commonObj.weightChargeList
                } else {
                    this.weightList = this.commonObj.weightChargeList
                }
            },
            fraudCheck (mobileNo) {
                const params = { mobile: mobileNo }
                config.getData(`/order/fraud-check`, params)
                .then((response) => {
                    if (response.success) {
                        this.isUnderReview = true
                    } else {
                        this.isUnderReview = false 
                    }
                    this.fraudResponse = true
                    this.fraud = response.data
                });
            },
            formatWeight() {
                let cleanValue = this.rawWeight.toString().replace(/[^\d.]/g, '');
                if(cleanValue != 0) {
                    let weightForCharge = null;
                    let formattedWeight = cleanValue;

                    // Check if input is in kilograms (contains decimal or short number)
                    if (cleanValue.includes('.') || cleanValue.length <= 2) {
                        // Keep as is (kilogram input like 0.7, 1.2)
                        formattedWeight = parseFloat(cleanValue).toString().replace(/\.?0+$/, '');
                    } else if (cleanValue.length >= 3) {
                        // Convert to kilograms if input is in grams (e.g., 1200 -> 1.2)
                        const gram = parseInt(cleanValue);
                        const kg = gram / 1000;
                        formattedWeight = kg.toFixed(3).replace(/\.?0+$/, '');
                    }

                    // Update form and rawWeight with formatted value (base value unchanged for display)
                    this.form.weight = formattedWeight;
                    this.rawWeight = formattedWeight;

                    // Calculate weight to use for charging (round up for specific ranges)
                    const parsedWeight = parseFloat(formattedWeight);
                    if (parsedWeight <= 0.5) {
                        weightForCharge = parsedWeight; // e.g., 0 -> 0.5
                    } else if (parsedWeight <= 1.0) {
                        weightForCharge = Math.ceil(parsedWeight); // e.g., 0.7 -> 1
                    } else if (parsedWeight <= 2.0) {
                        weightForCharge = Math.ceil(parsedWeight); // e.g., 1.1 -> 2
                    } else if (parsedWeight <= 3.0) {
                        weightForCharge = 3; // e.g., 2.1 to 3.0 -> 3
                    } else {
                        weightForCharge = Math.ceil(parsedWeight); // e.g., 3.2 -> 4
                    }

                    this.form.weight_charge = this.getWeightCharge(weightForCharge);
                }
            },
            getWeightCharge(inputWeight) {
                const weight = parseFloat(inputWeight);

                let weightItem = null;
                for (let item of this.weightList) {
                    const weightRange = item.text.toLowerCase().replace(/kg/g, '').trim();

                    if (weightRange.includes('to above')) {
                        const lower = parseFloat(weightRange.split('to')[0].trim());
                        if (weight >= lower) {
                            weightItem = item;
                            break;
                        }
                    } else {
                        const parts = weightRange.split('to');
                        const lower = parseFloat(parts[0].trim());
                        const upper = parseFloat(parts[1].trim());
                        if (weight >= lower && weight <= upper) {
                            weightItem = item;
                            break;
                        }
                    }
                }
                
                if (!weightItem) {
                    return 0;
                }
                const getTkValue = (item) => {
                    if (this.merchantDetails.district_id == this.form.district_id) {
                        if (this.merchantDetails.district_id == 14) {
                            if (this.merchantDetails.thana_id == this.form.thana_id) {
                                return parseFloat(item.sc_tk_value || 0);
                            }
                            else if (Array.isArray(this.subAreaCoverageThanaIds) && this.subAreaCoverageThanaIds.includes(parseInt(this.form.thana_id))) {
                                return parseFloat(item.sa_tk_value || 0);
                            }
                            else {
                                return parseFloat(item.isd_tk_value || 0);
                            }
                        }
                        else {
                            return parseFloat(item.sc_tk_value || 0);
                        }
                    }
                    else if (this.form.coverage_area_id == 1) {
                        return parseFloat(item.isd_tk_value || 0);
                    }
                    else if (this.form.coverage_area_id == 2) {
                        return parseFloat(item.osd_tk_value || 0);
                    }
                    else if (this.form.coverage_area_id == 3) {
                        return parseFloat(item.sa_tk_value || 0);
                    }
                    return 0;
                };

                let totalCharge = 0;

                for (let item of this.weightList) {
                    if (item.id < weightItem.id) {
                        totalCharge += parseFloat(getTkValue(item));
                    }
                }

                // open-ended last slab ('3Kg to Above' on old merchants, '4Kg to Above' on new): per-kg beyond its lower bound
                const aboveLower = weightItem.text.toLowerCase().includes('to above') ? parseFloat(weightItem.text) : NaN;
                if (!isNaN(aboveLower) && weight > aboveLower) {
                    const totalKg = Math.ceil(weight);
                    const extraKg = totalKg - aboveLower;

                    const firstKgCharge = parseFloat(getTkValue(weightItem));
                    const perKgCharge = parseFloat(firstKgCharge);  // you can adjust if you have separate tk_per_kg

                    // totalCharge += firstKgCharge + (extraKg * perKgCharge);
                    totalCharge += (extraKg * perKgCharge);
                } else {
                    totalCharge += parseFloat(getTkValue(weightItem));
                }

                return totalCharge;
            },
            async checkUnderReviewParcel () {
                this.loading = true
                const response = await config.getData('under-review/list', this.form)
                this.loading = false
                if (response.status == 200 && response.total > 0) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, this merchant parcel is pending in under review',
                        color: '#dc3545'
                    })
                    this.isUnderReview = true
                } else {
                    this.isUnderReview = false
                }
            },
            async saveForm () {
                this.loading = true
                const response = await config.postData('order/store', this.form)
                this.loading = false
                if (response.success) {
                    this.setDefaultForm()
                    // this.underReviewOrder()
                    this.$toast.success({
                        title: 'Success',
                        message: response.message,
                        color: '#218838'
                    })  
                    this.printLabel(response.data)
                } else {
                    this.$toast.error({
                        title: 'Error',
                        message: response.message,
                        color: '#dc3545'
                    })
                    this.$refs.form.setErrors(response.errors) 
                }
            },
            setDefaultForm () {
                this.form.name = this.form.mobile = this.form.mobile_2 = this.form.thana_id = this.form.district_id = this.form.destination_hub_id = ''
                this.form.zone_id = this.form.area_id = this.form.address = this.form.ref_id = this.form.instruction = this.form.description = this.search.mobile = ''
                this.form.category_id = 1,
                this.form.price = this.form.weight = this.form.weight_charge = 0
                this.rawWeight = 0;
                this.form.exchange = 2              
                this.$nextTick(() => {
                    this.$refs.form.reset()
                })
            },
            getThanaList (districtId) {
                return this.commonObj.thanaList.filter(el => el.district_id == districtId)
            },
            getAreaList (thanaId) {
                return this.commonObj.areaList.filter(el => el.thana_id == thanaId)
            },
            setHub (areaId) {
                const area = this.commonObj.areaList.find(el => el.id == areaId)
                // const area = this.merchantAreaList.find(el => el.id == areaId)
                this.form.district_id = area.district_id // added when area manage from merchant area
                this.form.thana_id = area.thana_id // added when area manage from merchant area
                this.form.destination_hub_id = area.hub_id
                this.form.coverage_area_id = area.coverage_area_id
            },
            getBase64Logo (logo) {
                var canvas = document.createElement('canvas')
                canvas.width = logo.width
                canvas.height = logo.height
                var ctx = canvas.getContext('2d')
                ctx.drawImage(logo, 0, 0)
                var dataURL = canvas.toDataURL('image/png')
                return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
            },
            printLabel(item) {
                this.printOrders = []
                this.printOrders.push(item)
                const base64Logo = this.getBase64Logo(document.getElementById('logoId'))
                Label.exportLabelDetails(base64Logo, this.printOrders)
            },
            setMerchantDetails(merchantId) {
                this.merchantDetails = this.commonObj.merchantList.find(el => el.id == merchantId)
                this.subAreaCoverageThanaIds = this.commonObj.thanaList.filter(el => el.coverage_area_id == 3).map(el => parseInt(el.id));
            }
        }
    }
</script>
<style scoped>
    @media print{
        body {
            margin-left:-10px;
        }
    }
    .mt-30 {
        margin-top: 30px !important;
    }
    .mt-40 {
        margin-top: 40px !important;
    }
    .booking-page .form-group label, .booking-page .form-group select option, .booking-page .form-group input::placeholder,  .booking-page .form-group input{
        font-size: 17px;
    }

    /* For Desktop View */
        @media screen and (min-width: 1024px) {
            .gfg-div {
                background-color: #63c971;
                color: #fff;
            }
        }
        
        /* For Tablet View */
        @media screen and (min-device-width: 768px) 
            and (max-device-width: 1024px) {
            .gfg-div {
                width: 400px;
                height: 400px;
                background-color: orange;
                color: black;
            }
        }
        
        /* For Mobile Portrait View */
        @media screen and (max-device-width: 480px) 
            and (orientation: portrait) {
            .gfg-div {
                width: 200px;
                height: 200px;
                background-color: red;
                color: #fff;
            }
        }
        
        /* For Mobile Landscape View */
        @media screen and (max-device-width: 640px) 
            and (orientation: landscape) {
            .gfg-div {
                width: 400px;
                height: 200px;
                background-color: cyan;
                color: black;
            }
        }
        
        /* For Mobile Phones Portrait or Landscape View */
        @media screen
            and (max-device-width: 640px) {
            .gfg-div {
                width: 400px;
                height: 200px;
                background-color: chartreuse;
                color: black;
            }
        }
        
        /* For iPhone 4 Portrait or Landscape View */
        @media screen and (min-device-width: 320px) 
            and (-webkit-min-device-pixel-ratio: 2) {
            .gfg-div {
                width: 400px;
                height: 400px;
                background-color: brown;
                color: black;
            }
        }
        
        /* For iPhone 5 Portrait or Landscape View */
        @media (device-height: 568px) 
            and (device-width: 320px) 
            and (-webkit-min-device-pixel-ratio: 2) {
            .gfg-div {
                width: 400px;
                height: 400px;
                background-color: cornflowerblue;
                color: black;
            }
        }
        
        /* For iPhone 6 and 6 plus Portrait or Landscape View */
        @media (min-device-height: 667px) 
            and (min-device-width: 375px) 
            and (-webkit-min-device-pixel-ratio: 3) {
            .gfg-div {
                width: 400px;
                height: 400px;
                background-color: darkgoldenrod;
                color: black;
            }
        };
</style>